export enum HMAC_ERROR_CODE {
  INVALID = 'HMAC_INVALID',
  UNAVAILABLE = 'HMAC_UNAVAILABLE',
}

export const isHmacErrorCode = (code: unknown): code is HMAC_ERROR_CODE => {
  return code === HMAC_ERROR_CODE.INVALID || code === HMAC_ERROR_CODE.UNAVAILABLE;
};
